module.exports = __webpack_public_path__ + "img/zhuangtai.b6619ef4.png";